/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LicenseSummaryData {
    getFixupPrototypeFunction() { return LicenseSummaryData.fixupPrototype; }

    static newInstance(model: Partial<LicenseSummaryData>): LicenseSummaryData {
        let obj = Object.assign(new LicenseSummaryData(), model);
        LicenseSummaryData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LicenseSummaryData>): LicenseSummaryData {
        if (!model) return null;
        return LicenseSummaryData.newInstance(<LicenseSummaryData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LicenseSummaryData) {
        if (!obj) return;

        models.LicenseSummaryData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LicenseSummaryData): boolean {
        Object.setPrototypeOf(obj, LicenseSummaryData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.potential_cost_saving === undefined) {
            this.potential_cost_saving = 0;
        }
        if (this.savings_percentage === undefined) {
            this.savings_percentage = 0;
        }
    }

    /**
     * Virtual Machine Name
     */
    virtual_machine_name: string;

    /**
     * Virtual Machine ID
     */
    virtual_machine_id: string;

    /**
     * Azure Hybrid Benefit
     */
    azure_hybrid_benefit: string;

    /**
     * Resource Location
     */
    resource_location: string;

    /**
     * Recommendation ID
     */
    recommendation_id: string;

    /**
     * Cloud Provider for the cloud account
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Potential Cost Saving
     */
    potential_cost_saving: number;

    /**
     * Service Account Name
     */
    service_account_name: string;

    /**
     * Tenant Name
     */
    tenant_name: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Subscription Name
     */
    subscription_name: string;

    /**
     * Subscription Id
     */
    subscription_id: string;

    /**
     * Cloud Account ID
     */
    cloud_account_id: string;

    /**
     * Potential Savings % compared to the Forecasted Spend
     */
    info: string;

    /**
     * Savings Percentage
     */
    savings_percentage: number;

}
